import {useCallback} from "react";
import {useStores} from "~/stores";
import {formatUnitPrice} from "../domain/unitPrice";

/** Unit prices in the workspace currency, precise at any magnitude (see `formatUnitPrice`). */
export function usePriceFormat(): (v: number | null | undefined) => string {
    const {p} = useStores();
    const currency = p.p.currency;
    return useCallback(v => formatUnitPrice(v, currency), [currency]);
}
